import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { AppBar, Layout } from 'react-admin'
import { useDispatch, useSelector } from 'react-redux'
import { clearBanner } from 'shared/actions/ui/actions'
import { Snackbars } from 'shared/components/Snackbars/Snackbars'
import { errorD1, marigoldOrange, midGray, white } from 'shared/theme/colors'

import { detectEnvironment } from './config/config'
import CustomMenu from './customMenu'
import { useLogRocket } from './hooks/useLogRocket'

const environmentBannerColor = {
  DEVELOPMENT: midGray,
  STAGING: marigoldOrange,
  PRODUCTION: errorD1,
  PREVIEW: midGray,
  UNKNOWN: midGray,
}[detectEnvironment()]

const CustomAppBar = (props: any) => {
  const dispatch = useDispatch()
  useLogRocket()

  return (
    <AppBar {...props}>
      <Typography variant="h6" id="react-admin-title" style={{ flex: 1 }} />
      <Snackbars onClose={() => dispatch(clearBanner())} useSelector={useSelector} />
      <Box sx={{ bgcolor: environmentBannerColor, textAlign: 'center', mx: 'auto', width: 200 }}>
        <Typography style={{ color: white, fontWeight: 800 }}>{detectEnvironment()}</Typography>
      </Box>
    </AppBar>
  )
}

const CustomLayout = (props: any) => <Layout {...props} appBar={CustomAppBar} menu={CustomMenu} />

export default CustomLayout
